import loadable from '@loadable/component' // 路由懒加载，【注意】：懒加载组件必须通过 default 默认导出，其他导出方式会报错

/* 欢迎页 - 项目管理页面 */
const Home = loadable(() => import('pages/Home/Home')) // 新建与管理项目
// const AIChat = loadable(() => import('pages/AIChat/AIChat')) // ai

/* 共享页面 */
const Demo = loadable(() => import('pages/common/Demo/Demo')) // demo 测试
const Error = loadable(() => import('pages/common/Error/Error')) // 404
const Profile = loadable(() => import('pages/common/Profile/Profile')) // 404
const FVSList = loadable(() => import('pages/common/FVSList/FVSList')) // 帆软列表

/* 仪表盘页面 */
const ProjectOverview = loadable(() => import('pages/dashboard/ProjectOverview/ProjectOverview')) // 项目仪表盘
const ProjectOverviewLand = loadable(() => import('pages/dashboard/ProjectOverviewLand/ProjectOverviewLand')) // 项目仪表盘 TZ
const ProjectOverviewStreamer = loadable(() =>
    import('pages/dashboard/ProjectOverviewStreamer/ProjectOverviewStreamer')
) // 项目托缆仪表盘
const HSEOverview = loadable(() => import('pages/dashboard/HSEOverview/HSEOverview')) // HSE 概览
const ReceiverStatistics = loadable(() => import('pages/dashboard/ReceiverStatistics/ReceiverStatistics')) // 节点收放统计
const ReceiverStatisticsLand = loadable(() => import('pages/dashboard/ReceiverStatisticsLand/ReceiverStatisticsLand')) // 节点收放统计 TZ
const TimingStatistics = loadable(() => import('pages/dashboard/TimingStatistics/TimingStatistics')) // 时效统计
const SourceStatistics = loadable(() => import('pages/dashboard/SourceStatistics/SourceStatistics')) // 放炮统计
const ConsumableOverview = loadable(() => import('pages/dashboard/Consumable/Consumable')) // 油水统计
const SourceStatisticsLand = loadable(() => import('pages/dashboard/SourceStatisticsLand/SourceStatisticsLand')) // 放炮统计
const ProfitIncome = loadable(() => import('pages/dashboard/ProfitIncome/ProfitIncome')) // 市场营收
const SourceStatisticsStreamer = loadable(() =>
    import('pages/dashboard/SourceStatisticsStreamer/SourceStatisticsStreamer')
) // 拖缆统计

/* 生产计划页面 */
const WeeklyPlan = loadable(() => import('pages/plan/WeeklyPlan/WeeklyPlan')) // HSE 日志

/* 监视器 - 录入数据页面 */
const HseDiary = loadable(() => import('pages/monitor/HseDiary/HseDiary')) // HSE 日志
const HseDiaryDetail = loadable(() => import('pages/monitor/HseDiary/HseDiaryDetail')) // HSE 日志详情
const WeekHseDiaryDetail = loadable(() => import('pages/monitor/HseDiary/WeekHseDiaryDetail')) // 周日志详情
const MonthHseDiaryDetail = loadable(() => import('pages/monitor/HseDiary/MonthHseDiaryDetail')) // 月 HSE 日志详情
const HealthDiary=loadable(() => import('pages/monitor/HealthDiary/HealthDiary')) // 健康管理
const HealthDiaryDetail=loadable(() => import('pages/monitor/HealthDiary/HealthDiaryDetail')) // 健康管理详情
const HseIncident = loadable(() => import('pages/monitor/HseIncident/HseIncident')) // HSE 事故
const HseIncidentDetail = loadable(() => import('pages/monitor/HseIncident/HseIncidentDetail')) // HSE 事故详情
const Waste = loadable(() => import('pages/monitor/Waste/Waste')) // 废物处理
const WasteDetail = loadable(() => import('pages/monitor/Waste/WasteDetail')) // 废物处理详情
const Consumable = loadable(() => import('pages/monitor/Consumable/Consumable')) // 消耗品
const ConsumableDetail = loadable(() => import('pages/monitor/Consumable/ConsumableDetail')) // 消耗品详情
const ROV = loadable(() => import('pages/monitor/ROV/ROV')) // ROV
const ROVDetail = loadable(() => import('pages/monitor/ROV/ROVDetail')) // ROV 详情
const USV = loadable(() => import('pages/monitor/USV/USV')) // USV
const USVDetail = loadable(() => import('pages/monitor/USV/USVDetail')) // USV 详情
const RWP = loadable(() => import('pages/monitor/RWP/RWP')) // RWP
const Weather = loadable(() => import('pages/monitor/Weather/Weather')) // 天气
const WeatherDetail = loadable(() => import('pages/monitor/Weather/WeatherDetail')) // 天气详情
const Workboat = loadable(() => import('pages/monitor/Workboat/Workboat')) // 工作船
const WorkboatDetail = loadable(() => import('pages/monitor/Workboat/WorkboatDetail')) // 工作船详情
const Helicopter = loadable(() => import('pages/monitor/Helicopter/Helicopter')) // 直升机
const HelicopterDetail = loadable(() => import('pages/monitor/Helicopter/HelicopterDetail')) // 直升机详情
const ActivityDiary = loadable(() => import('pages/monitor/ActivityDiary/ActivityDiary')) // 活动日志
const ActivityDiaryDetail = loadable(() => import('pages/monitor/ActivityDiary/ActivityDiaryDetail')) // 活动日志详情
const FleetSummary = loadable(() => import('pages/monitor/FleetSummary/FleetSummary')) // 船队信息
const FleetSummaryDetail = loadable(() => import('pages/monitor/FleetSummary/FleetSummaryDetail')) // 船队信息详情
const WeekFleetSummaryDetail = loadable(() => import('pages/monitor/FleetSummary/WeekFleetSummaryDetail')) // 周 船队信息详情
const MonthFleetSummaryDetail = loadable(() => import('pages/monitor/FleetSummary/MonthFleetSummaryDetail')) // 月 船队信息详情
const AcquisitionObn = loadable(() => import('pages/monitor/Acquisition/Acquisition')) // 炮点激发 OBN
const AcquisitionDetail = loadable(() => import('pages/monitor/Acquisition/AcquisitionDetail')) // 炮点激发详情 OBN
const AcquisitionStreamer = loadable(() => import('pages/monitor/Source/Source')) // 炮点激发 拖缆
const SourceDetail = loadable(() => import('pages/monitor/Source/SourceDetail')) // 炮点激发详情 拖缆
const FocusAcquisition = loadable(() => import('pages/monitor/FocusAcquisition/FocusAcquisition')) // 震源激发 TZ
const FocusAcquisitionDetail = loadable(() => import('pages/monitor/FocusAcquisition/FocusAcquisitionDetail')) // 震源激发详情 TZ
const Magnetism = loadable(() => import('pages/monitor/Magnetism/Magnetism')) // 炮点激发 拖缆
const MagnetismDetail = loadable(() => import('pages/monitor/Magnetism/MagnetismDetail')) // 炮点激发详情 拖缆
const Receive = loadable(() => import('pages/monitor/Receive/Receive')) // 接收系统 - 海上
const ReceiveDetail = loadable(() => import('pages/monitor/Receive/ReceiveDetail')) // 接收系统详情 - 海上
const ReceiveLand = loadable(() => import('pages/monitor/ReceiveLand/ReceiveLand')) // 接收系统 - 陆上
const ReceiveLandDetail = loadable(() => import('pages/monitor/ReceiveLand/ReceiveLandDetail')) // 接收系统详情 - 陆上
const MMO = loadable(() => import('pages/monitor/MMO/MMO')) // MMO
const MMODetail = loadable(() => import('pages/monitor/MMO/MMODetail')) // MMODetail
const Drill = loadable(() => import('pages/monitor/Drill/Drill')) // 钻井录入
const DrillDetail = loadable(() => import('pages/monitor/Drill/DrillDetail')) // 钻井录入详情
const Clearance = loadable(() => import('pages/monitor/Clearance/Clearance')) // 清雷
const ClearanceDetail = loadable(() => import('pages/monitor/Clearance/ClearanceDetail')) // 清雷详情
const LineClearance = loadable(() => import('pages/monitor/LineClearance/LineClearance')) // 清线
const LineClearanceDetail = loadable(() => import('pages/monitor/LineClearance/LineClearanceDetail')) // 清线详情
const NearSurfaceInspection = loadable(() => import('pages/monitor/NearSurfaceInspection/NearSurfaceInspection')) // 表层调查
const NearSurfaceInspectionDetail = loadable(() =>
    import('pages/monitor/NearSurfaceInspection/NearSurfaceInspectionDetail')
) // 表层调查详情
const NonSeismic = loadable(() => import('pages/monitor/NonSeismic/NonSeismic')) // 非地震
const NonSeismicDetail = loadable(() => import('pages/monitor/NonSeismic/NonSeismicDetail')) // 非地震详情
const OnSiteProcessing = loadable(() => import('pages/monitor/OnSiteProcessing/OnSiteProcessing')) // 现场处理
const OnSiteProcessingDetail = loadable(() => import('pages/monitor/OnSiteProcessing/OnSiteProcessingDetail')) // 现场处理详情
const Permit = loadable(() => import('pages/monitor/Permit/Permit')) // 工农
const PermitDetail = loadable(() => import('pages/monitor/Permit/PermitDetail')) // 工农详情
const Loading = loadable(() => import('pages/monitor/Loading/Loading')) // 下药
const LoadingDetail = loadable(() => import('pages/monitor/Loading/LoadingDetail')) // 下药详情
const Materials = loadable(() => import('pages/monitor/Materials/Materials')) // 耗材
const MaterialsDetail = loadable(() => import('pages/monitor/Materials/MaterialsDetail')) // 耗材详情
const Vehicle = loadable(() => import('pages/monitor/Vehicle/Vehicle')) // 耗材
const VehicleDetail = loadable(() => import('pages/monitor/Vehicle/VehicleDetail')) // 耗材详情
const Measurement = loadable(() => import('pages/monitor/Measurement/Measurement')) // 测量
const MeasurementDetail = loadable(() => import('pages/monitor/Measurement/MeasurementDetail')) // 测量详情

/* 项目设置 - 相关页面 */
const ProjectConfig = loadable(() => import('pages/setting/ProjectDetails/ProjectBasicInfo/ProjectConfig')) // 项目信息配置
const Geometry = loadable(() => import('pages/setting/ProjectDetails/Geometry/Geometry')) // Geometry 配置
const Workload = loadable(() => import('pages/setting/ProjectDetails/Workload/Workload')) // Workload 配置
const Companys = loadable(() => import('pages/setting/Resources/Companys/Companys')) // Resources-Companys
const Locations = loadable(() => import('pages/setting/Resources/Locations/Locations')) // Resources-Locations
const Users = loadable(() => import('pages/setting/Resources/Users/Users')) // Resources-Users
const SourceSystem = loadable(() => import('pages/setting/Resources/SourceSystem/SourceSystem')) // Resources-SourceSystem
const Terrain = loadable(() => import('pages/setting/ProjectDetails/Terrain/Terrain')) // 地形
const ReceiverSystem = loadable(() => import('pages/setting/Resources/ReceiverSystem/ReceiverSystem')) // 接收信息
const RecordingSystem = loadable(() => import('pages/setting/Resources/RecordingSystem/RecordingSystem')) // Resources-RecordingSystem

const Compensation = loadable(() => import('pages/setting/Resources/Compensation/Compensation')) // 施工单价
const LogSetting = loadable(() => import('pages/setting/LogSetting/LogSetting')) // 日志字典
const OperationManual = loadable(() => import('pages/setting/OperationManual/OperationManual')) // 操作手册
const Boundaries = loadable(() => import('pages/setting/ProjectDetails/Boundaries/Boundaries')) // 边框
const Obstacles = loadable(() => import('pages/setting/ProjectDetails/Obstacles/Obstacles')) // 障碍物
const Zipper = loadable(() => import('pages/setting/ProjectDetails/Zipper/Zipper')) // 日志字典

/* 国际部 计划 */
const MaterialPlan = loadable(() => import('pages/setting/Plan/MaterialPlan/MaterialPlan')) // 材料计划
const EquipmentTransfer = loadable(() => import('pages/setting/Plan/EquipmentTransfer/EquipmentTransfer')) // 材料计划
const MobilisationPlan = loadable(() => import('pages/setting/Plan/MobilisationPlan/MobilisationPlan')) // 动迁计划
const BudgetQuotation = loadable(() => import('pages/setting/Plan/BudgetQuotation/BudgetQuotation')) // 预算
const EquipmentPlan = loadable(() => import('pages/setting/Plan/EquipmentPlan/EquipmentPlan')) // 设备
const ProjectPlanLandNode = loadable(() => import('pages/setting/Plan/ProjectPlanLandNode/ProjectPlanLandNode')) // 生产计划
const PersonnelPlan = loadable(() => import('pages/setting/Plan/PersonnelPlan/PersonnelPlan')) // 人员计划

/* 工具方法 */
const Map = loadable(() => import('pages/functions/Map/Map')) // 地图
const Report = loadable(() => import('pages/functions/Report/Report')) // 报表系统
// const ReportStreamer = loadable(() => import('pages/functions/ReportStreamer/ReportStreamer')) // 报表系统

export const getRouterTree = (t, receiverTypeList) => [
    {
        path: '/',
        exact: true,
        element: receiverTypeList ? (
            receiverTypeList?.includes('obn') ? (
                <ProjectOverview />
            ) : receiverTypeList?.includes('streamer') ? (
                <ProjectOverviewStreamer />
            ) : (
                <ProjectOverviewLand />
            )
        ) : (
            <></>
        ),
    },
    {
        path: '/dashboard/projectOverview',
        exact: true,
        element: <ProjectOverview />,
    },
    {
        path: '/dashboard/ProjectOverviewLand',
        exact: true,
        element: <ProjectOverviewLand />,
    },
    {
        path: '/dashboard/projectOverviewStreamer',
        exact: true,
        element: <ProjectOverviewStreamer />,
    },
    {
        path: '/dashboard/HSEOverview',
        exact: true,
        element: <HSEOverview />,
    },
    {
        path: '/dashboard/receiverStatistics',
        exact: true,
        element: <ReceiverStatistics />,
    },
    {
        path: '/dashboard/ReceiverStatisticsLand',
        exact: true,
        element: <ReceiverStatisticsLand />,
    },
    {
        path: '/dashboard/timingStatistics',
        exact: true,
        element: <TimingStatistics />,
    },
    {
        path: '/dashboard/sourceStatistics',
        exact: true,
        element: <SourceStatistics />,
    },
    {
        path: '/dashboard/ConsumableOverview',
        exact: true,
        element: <ConsumableOverview />,
    },
    {
        path: '/dashboard/SourceStatisticsLand',
        exact: true,
        element: <SourceStatisticsLand />,
    },
    {
        path: '/dashboard/ProfitIncome',
        exact: true,
        element: <ProfitIncome />,
    },
    {
        path: '/dashboard/sourceStatisticsStreamer',
        exact: true,
        element: <SourceStatisticsStreamer />,
    },
    {
        path: '*',
        element: <Error />,
    },
    {
        path: '/demo',
        exact: true,
        element: <Demo />,
    },
    {
        path: '/profile',
        exact: true,
        element: <Profile />,
    },
    {
        path: '/fvs_list',
        exact: true,
        element: <FVSList />,
    },
    {
        path: '/weekly_plan',
        exact: true,
        element: <WeeklyPlan />,
    },
    {
        path: '/hse_diary',
        exact: true,
        element: <HseDiary />,
    },
    {
        path: '/hse_diary/detail',
        exact: true,
        element: <HseDiaryDetail />,
    },
    {
        path: '/hse_diary/weekDetail',
        exact: true,
        element: <WeekHseDiaryDetail />,
    },
    {
        path: '/hse_diary/monthDetail',
        exact: true,
        element: <MonthHseDiaryDetail />,
    },
    {
        path: '/health_diary',
        exact: true,
        element: <HealthDiary />,
    },
    {
        path: '/health_diary/detail',
        exact: true,
        element: <HealthDiaryDetail />,
    },
    {
        path: '/hse_incident',
        exact: true,
        element: <HseIncident />,
    },
    {
        path: '/hse_incident/detail',
        exact: true,
        element: <HseIncidentDetail />,
    },
    {
        path: '/waste_disposal',
        exact: true,
        element: <Waste />,
    },
    {
        path: '/waste_disposal/detail',
        exact: true,
        element: <WasteDetail />,
    },
    {
        path: '/consumable',
        exact: true,
        element: <Consumable />,
    },
    {
        path: '/consumable/detail',
        exact: true,
        element: <ConsumableDetail />,
    },
    {
        path: '/mmo',
        exact: true,
        element: <MMO />,
    },
    {
        path: '/mmo/detail',
        exact: true,
        element: <MMODetail />,
    },
    // 钻井
    {
        path: '/drill',
        exact: true,
        element: <Drill />,
    },
    {
        path: '/Drill/detail',
        exact: true,
        element: <DrillDetail />,
    },
    // 清雷
    {
        path: '/clearance',
        exact: true,
        element: <Clearance />,
    },
    {
        path: '/clearance/detail',
        exact: true,
        element: <ClearanceDetail />,
    },
    // 清线
    {
        path: '/lineClearance',
        exact: true,
        element: <LineClearance />,
    },
    {
        path: '/lineClearance/detail',
        exact: true,
        element: <LineClearanceDetail />,
    },
    // 表层调查
    {
        path: '/nearSurfaceInspection',
        exact: true,
        element: <NearSurfaceInspection />,
    },
    {
        path: '/NearSurfaceInspection/detail',
        exact: true,
        element: <NearSurfaceInspectionDetail />,
    },
    {
        path: '/nonSeismic',
        exact: true,
        element: <NonSeismic />,
    },
    {
        path: '/nonSeismic/detail',
        exact: true,
        element: <NonSeismicDetail />,
    },
    {
        path: '/onSiteProcessing',
        exact: true,
        element: <OnSiteProcessing />,
    },
    {
        path: '/onSiteProcessing/detail',
        exact: true,
        element: <OnSiteProcessingDetail />,
    },
    {
        path: '/permit',
        exact: true,
        element: <Permit />,
    },
    {
        path: '/permit/detail',
        exact: true,
        element: <PermitDetail />,
    },
    {
        path: '/loading',
        exact: true,
        element: <Loading />,
    },
    {
        path: '/loading/detail',
        exact: true,
        element: <LoadingDetail />,
    },
    {
        path: '/materials',
        exact: true,
        element: <Materials />,
    },
    {
        path: '/materials/detail',
        exact: true,
        element: <MaterialsDetail />,
    },
    {
        path: '/vehicle',
        exact: true,
        element: <Vehicle />,
    },
    {
        path: '/vehicle/detail',
        exact: true,
        element: <VehicleDetail />,
    },
    {
        path: '/measurement',
        exact: true,
        element: <Measurement />,
    },
    {
        path: '/measurement/detail',
        exact: true,
        element: <MeasurementDetail />,
    },
    {
        path: '/rov',
        exact: true,
        element: <ROV />,
    },
    {
        path: '/rov/detail',
        exact: true,
        element: <ROVDetail />,
    },
    {
        path: '/usv',
        exact: true,
        element: <USV />,
    },
    {
        path: '/usv/detail',
        exact: true,
        element: <USVDetail />,
    },
    {
        path: '/rwp',
        exact: true,
        element: <RWP />,
    },
    {
        path: '/weather',
        exact: true,
        element: <Weather />,
    },
    {
        path: '/weather/detail',
        exact: true,
        element: <WeatherDetail />,
    },
    {
        path: '/work_boat',
        exact: true,
        element: <Workboat />,
    },
    {
        path: '/work_boat/detail',
        exact: true,
        element: <WorkboatDetail />,
    },
    {
        path: '/helicopter',
        exact: true,
        element: <Helicopter />,
    },
    {
        path: '/helicopter/detail',
        exact: true,
        element: <HelicopterDetail />,
    },
    {
        path: '/activity_diary',
        exact: true,
        element: <ActivityDiary />,
    },
    {
        path: '/activity_diary/detail',
        exact: true,
        element: <ActivityDiaryDetail />,
    },
    {
        path: '/project_summary',
        exact: true,
        element: <FleetSummary />,
    },
    {
        path: '/project_summary/detail',
        exact: true,
        element: <FleetSummaryDetail />,
    },
    {
        path: '/project_summary/weekDetail',
        exact: true,
        element: <WeekFleetSummaryDetail />,
    },
    {
        path: '/project_summary/monthDetail',
        exact: true,
        element: <MonthFleetSummaryDetail />,
    },
    {
        path: '/acquisition_obn',
        exact: true,
        element: <AcquisitionObn />,
    },
    {
        path: '/acquisition_streamer',
        exact: true,
        element: <AcquisitionStreamer />,
    },
    {
        path: '/vibrator',
        exact: true,
        element: <FocusAcquisition />,
    },
    {
        path: '/vibrator/detail',
        exact: true,
        element: <FocusAcquisitionDetail />,
    },
    {
        path: '/source/detail',
        exact: true,
        element: <SourceDetail />,
    },
    {
        path: '/magnetism',
        exact: true,
        element: <Magnetism />,
    },
    {
        path: '/magnetism/detail',
        exact: true,
        element: <MagnetismDetail />,
    },
    {
        path: '/acquisition_obn/detail',
        exact: true,
        element: <AcquisitionDetail />,
    },
    {
        path: '/receiver',
        exact: true,
        element: <Receive />,
    },
    {
        path: '/receiver/detail',
        exact: true,
        element: <ReceiveDetail />,
    },
    {
        path: '/receiver_land',
        exact: true,
        element: <ReceiveLand />,
    },
    {
        path: '/receiver_land/detail',
        exact: true,
        element: <ReceiveLandDetail />,
    },
    {
        path: '/setting/projectDetails/projectConfig',
        exact: true,
        element: <ProjectConfig />,
    },
    {
        path: '/setting/projectDetails/geometry',
        exact: true,
        element: <Geometry />,
    },
    {
        path: '/setting/projectDetails/terrain',
        exact: true,
        element: <Terrain />,
    },
    {
        path: '/setting/projectDetails/workload',
        exact: true,
        element: <Workload />,
    },
    {
        path: '/setting/resources/companys',
        exact: true,
        element: <Companys />,
    },
    {
        path: '/setting/resources/locations',
        exact: true,
        element: <Locations />,
    },
    {
        path: '/setting/resources/users',
        exact: true,
        element: <Users />,
    },
    {
        path: '/setting/resources/equipment/sourceSystem',
        exact: true,
        element: <SourceSystem />,
    },
    {
        path: '/setting/resources/equipment/receiverSystem',
        exact: true,
        element: <ReceiverSystem />,
    },
    {
        path: '/setting/resources/equipment/recordingSystem',
        exact: true,
        element: <RecordingSystem />,
    },
    {
        path: '/setting/Compensation',
        exact: true,
        element: <Compensation />,
    },
    {
        path: '/setting/LogSettings',
        exact: true,
        element: <LogSetting />,
    },
    {
        path: '/setting/OperationManual',
        exact: true,
        element: <OperationManual />,
    },
    {
        path: '/home',
        exact: true,
        element: <Home />,
    },
    // {
    //     path: '/AIChat',
    //     exact: true,
    //     element: <AIChat />,
    // },
    {
        path: '/functions/map',
        exact: true,
        element: <Map />,
    },
    {
        path: '/functions/report',
        exact: true,
        element: <Report />,
    },
    {
        path: '/setting/projectDetails/Boundaries',
        exact: true,
        element: <Boundaries />,
    },
    {
        path: '/setting/projectDetails/Obstacles',
        exact: true,
        element: <Obstacles />,
    },
    {
        path: '/setting/projectDetails/Zipper',
        exact: true,
        element: <Zipper />,
    },
    /* 计划 */
    {
        path: '/setting/plan/MaterialPlan',
        exact: true,
        element: <MaterialPlan />,
    },
    {
        path: '/setting/plan/MobilisationPlan',
        exact: true,
        element: <MobilisationPlan />,
    },
    {
        path: '/setting/plan/BudgetQuotation',
        exact: true,
        element: <BudgetQuotation />,
    },
    {
        path: '/setting/plan/EquipmentPlan',
        exact: true,
        element: <EquipmentPlan />,
    },
    {
        path: '/setting/plan/ProjectPlanLandNode',
        exact: true,
        element: <ProjectPlanLandNode />,
    },
    {
        path: '/setting/plan/PersonnelPlan',
        exact: true,
        element: <PersonnelPlan />,
    },
    {
        path: '/setting/resources/equipment/EquipmentTransfer',
        exact: true,
        element: <EquipmentTransfer />,
    },
]
